/** «Hvor mange så det» (spec 01 C, components/SeenCount): the pure half — who sees the counts, and which ids are asked. */
export const VIEW_COUNTS_CAPABILITY = 'view_counts';
export type SeenKind = 'push' | 'notice' | 'banner' | 'event';
/** Who may read each kind (the API's own door, apps/api/src/view-marks.js READ): the line is not offered to others. */
export const SEEN_READ: Record<SeenKind, string[]> = {
  push: ['push.compose', 'push.approve'],
  notice: ['notices.write', 'notices.approve'],
  banner: ['screens.manage', 'banners.approve'],
  event: ['events.write'],
};
/** The API's limit per ask (core view-marks MAX_IDS). */
export const SEEN_MAX_IDS = 100;

/** Whether counts of this kind are shown at all: the mosque has `view_counts`, and this person may read the kind. */
export const seenShown = (caps: string[] | null | undefined, kind: SeenKind, may: (p: string) => boolean): boolean =>
  Boolean(caps && caps.includes(VIEW_COUNTS_CAPABILITY)) && SEEN_READ[kind].some(may);

/** The ids worth asking for: well-formed (the API's REF_RE), once each, at most SEEN_MAX_IDS, in the caller's order. */
export const seenIds = (ids: (string | null | undefined)[]): string[] =>
  [...new Set(ids.filter((x): x is string => typeof x === 'string' && /^[A-Za-z0-9._:-]{1,64}$/.test(x)))].slice(0, SEEN_MAX_IDS);
